// extracted by mini-css-extract-plugin
module.exports = {"rootS":"nba-tag_rootS__eWlp5","rootN":"nba-tag_rootN__yIZnS","shiningLine":"nba-tag_shiningLine__IjYjR","shine":"nba-tag_shine__gkGet"};